// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/BezierSans.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/BezierSans.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/fonts/BezierSans.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/fonts/BezierSansBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Bezier Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
         url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
    font-weight: normal;
    font-style: normal;

    
    font-family: 'Bezier Sans Bold';
    src:
         url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  body {
    font-family: 'Bezier Sans', sans-serif;
  }
.engineering {
    display: flex;
    justify-content: space-between;
    align-items: center;

    height: 100vh; /* Устанавливаем высоту контейнера равной высоте экрана */
    background-color: #dee9f5;
    
}

.engineering-content {
    display: flex;
    flex-direction: row;
    align-items: flex-start; /* Align items at the top */
    max-width: 1200px;
    margin: 0 auto;
    gap: 20px; /* Add space between image and text */
}

.engineering-image {
    flex: 1 1;
}

.engineering-image img {
    width: 100%;
    height: auto;
    max-width: 600px; /* Adjust as needed */
    border-radius: 8px; /* Optional: Add rounded corners */
}

.engineering-text {
    flex: 1 1;
    padding: 20px;
}

.main-text
{
    font-family: 'Bezier Sans Bold';
}

.engineering-text .main-text {
    font-size: 24px; /* Adjust font size as needed */
    line-height: 1.5;
    margin-bottom: 20px; /* Add space below the main text */
}

.engineering-text .additional-info {
    font-size: 18px; /* Adjust font size as needed */
    line-height: 1.6;
}

.engineering-text .additional-info p {
    font-size: 18px;
    line-height: 1.6;
}


@media (max-width: 768px) {

    @media (max-width: 768px) {
        .engineering {
          height: auto;
          flex-direction: column;
          padding: 20px;
        }
      
        .engineering-content {
          flex-direction: column-reverse; /* Меняем порядок на мобильных устройствах */
          align-items: center;
          text-align: center;
          width: 100%;
        }
      
        .engineering-text {
          /*justify-content:center;
          align-items: center;
          padding-left: 0;*/
          padding-bottom: 5px;
        }
      
        .engineering-image {
          margin-top: 5px;
        }
      
        .engineering-image img {
          max-width: 80%;
        }
      
        .home5 {
          height: auto;
          flex-direction: column;
          padding: 20px;
        }
      }

}

`, "",{"version":3,"sources":["webpack://./src/styles/Maturity.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B;;mEAEgE;IAChE,mBAAmB;IACnB,kBAAkB;;;IAGlB,+BAA+B;IAC/B;mEACoE;IACpE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,sCAAsC;EACxC;AACF;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;IAEnB,aAAa,EAAE,yDAAyD;IACxE,yBAAyB;;AAE7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAE,2BAA2B;IACpD,iBAAiB;IACjB,cAAc;IACd,SAAS,EAAE,qCAAqC;AACpD;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB,EAAE,qBAAqB;IACvC,kBAAkB,EAAE,kCAAkC;AAC1D;;AAEA;IACI,SAAO;IACP,aAAa;AACjB;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,eAAe,EAAE,+BAA+B;IAChD,gBAAgB;IAChB,mBAAmB,EAAE,kCAAkC;AAC3D;;AAEA;IACI,eAAe,EAAE,+BAA+B;IAChD,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;;AAGA;;IAEI;QACI;UACE,YAAY;UACZ,sBAAsB;UACtB,aAAa;QACf;;QAEA;UACE,8BAA8B,EAAE,4CAA4C;UAC5E,mBAAmB;UACnB,kBAAkB;UAClB,WAAW;QACb;;QAEA;UACE;;2BAEiB;UACjB,mBAAmB;QACrB;;QAEA;UACE,eAAe;QACjB;;QAEA;UACE,cAAc;QAChB;;QAEA;UACE,YAAY;UACZ,sBAAsB;UACtB,aAAa;QACf;MACF;;AAEN","sourcesContent":["@font-face {\r\n    font-family: 'Bezier Sans';\r\n    src: url('../../public/fonts/BezierSans.woff2') format('woff2'),\r\n         url('../../public/fonts/BezierSans.woff') format('woff'),\r\n         url('../../public/fonts/BezierSans.ttf') format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n\r\n    \r\n    font-family: 'Bezier Sans Bold';\r\n    src:\r\n         url('../../public/fonts/BezierSansBold.ttf') format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n  }\r\n  body {\r\n    font-family: 'Bezier Sans', sans-serif;\r\n  }\r\n.engineering {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n\r\n    height: 100vh; /* Устанавливаем высоту контейнера равной высоте экрана */\r\n    background-color: #dee9f5;\r\n    \r\n}\r\n\r\n.engineering-content {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: flex-start; /* Align items at the top */\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n    gap: 20px; /* Add space between image and text */\r\n}\r\n\r\n.engineering-image {\r\n    flex: 1;\r\n}\r\n\r\n.engineering-image img {\r\n    width: 100%;\r\n    height: auto;\r\n    max-width: 600px; /* Adjust as needed */\r\n    border-radius: 8px; /* Optional: Add rounded corners */\r\n}\r\n\r\n.engineering-text {\r\n    flex: 1;\r\n    padding: 20px;\r\n}\r\n\r\n.main-text\r\n{\r\n    font-family: 'Bezier Sans Bold';\r\n}\r\n\r\n.engineering-text .main-text {\r\n    font-size: 24px; /* Adjust font size as needed */\r\n    line-height: 1.5;\r\n    margin-bottom: 20px; /* Add space below the main text */\r\n}\r\n\r\n.engineering-text .additional-info {\r\n    font-size: 18px; /* Adjust font size as needed */\r\n    line-height: 1.6;\r\n}\r\n\r\n.engineering-text .additional-info p {\r\n    font-size: 18px;\r\n    line-height: 1.6;\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n\r\n    @media (max-width: 768px) {\r\n        .engineering {\r\n          height: auto;\r\n          flex-direction: column;\r\n          padding: 20px;\r\n        }\r\n      \r\n        .engineering-content {\r\n          flex-direction: column-reverse; /* Меняем порядок на мобильных устройствах */\r\n          align-items: center;\r\n          text-align: center;\r\n          width: 100%;\r\n        }\r\n      \r\n        .engineering-text {\r\n          /*justify-content:center;\r\n          align-items: center;\r\n          padding-left: 0;*/\r\n          padding-bottom: 5px;\r\n        }\r\n      \r\n        .engineering-image {\r\n          margin-top: 5px;\r\n        }\r\n      \r\n        .engineering-image img {\r\n          max-width: 80%;\r\n        }\r\n      \r\n        .home5 {\r\n          height: auto;\r\n          flex-direction: column;\r\n          padding: 20px;\r\n        }\r\n      }\r\n\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
